import { DBConfig } from "ngx-indexed-db";

export const dbConfig: DBConfig = {
  name: "evaDb",
  version: 1,
  objectStoresMeta: [
    {
      store: "dynamicStore",
      storeConfig: { keyPath: "id", autoIncrement: false },
      storeSchema: [
        { name: "value", keypath: "value", options: { unique: false } },
        { name: "timestamp", keypath: "timestamp", options: { unique: false } },
      ],
    },
  ],
};
